export const BERNOULLI_ADP_KEY = 'wlc360ai-w3f-bernoulli';

export type BernoulliAdpConfig = {
  name: string;
  id: string;
  id_provider: 'appkey';
  key: string;
  env: 'dev' | 'stg' | 'prd';
  region: 'us';
};

export const BERNOULLI_ADP_BY_ENV: Record<
  'dev' | 'stg' | 'prd',
  BernoulliAdpConfig
> = {
  dev: {
    name: 'W3F Bernoulli',
    id: 'UPGH1gDIvrt2I2oxmOa3PT5UUXfK7064NAonfEfQGcW8iZFG',
    id_provider: 'appkey',
    key: BERNOULLI_ADP_KEY,
    env: 'dev',
    region: 'us',
  },
  stg: {
    name: 'W3F Bernoulli',
    id: 'UPGH1gDIvrt2I2oxmOa3PT5UUXfK7064NAonfEfQGcW8iZFG',
    id_provider: 'appkey',
    key: BERNOULLI_ADP_KEY,
    env: 'stg',
    region: 'us',
  },
  prd: {
    name: 'W3F Bernoulli',
    id: 'VxnTgD5GzEGBLFGaqveSYWVRicouMoAQ89adTjlO0GtH36gM',
    id_provider: 'appkey',
    key: BERNOULLI_ADP_KEY,
    env: 'prd',
    region: 'us',
  },
};
